import { EEnvironment } from '@app/core/enums/environment.enum';

export const environment = {
  env: EEnvironment.production,
  hash: new Date().getTime(),
  api_url: 'https://api.bodil.io',
  sentryVersionPrefix: 'prod',
  sentryDsn: 'https://36905dbb09a04a9a86b05255ab5194fb@o4505550248607744.ingest.sentry.io/4505550809137152',
};
